import * as React from 'react';
import {
	Dropdown,
	DropdownContent,
	DropdownItem,
	DropdownSelectTrigger,
	DropdownSeparator,
} from '../../../../../../web/components-v2/Dropdown';
import { useSavedMessages } from '../../hooks/useSavedMessages';
import { s } from './styles';

interface SavedMessagesDropdownProps {
	onSelectMessage: (content: string, messageId: string) => void;
	onOpenManageDialog: () => void;
	currentMessageId: string | null;
	refreshKey?: number;
}

export const SavedMessagesDropdown: React.FC<SavedMessagesDropdownProps> = ({
	onSelectMessage,
	onOpenManageDialog,
	currentMessageId,
	refreshKey,
}) => {
	const { messages, lastUsedId } = useSavedMessages(refreshKey);

	const handleSelectMessage = (message: { id: string; content: string; label: string }) => {
		onSelectMessage(message.content, message.id);
	};

	// Get display text for trigger
	const getTriggerText = () => {
		if (messages.length === 0) {
			return 'Custom Message';
		}
		if (currentMessageId) {
			const message = messages.find(m => m.id === currentMessageId);
			return message?.label || 'Select Message';
		}
		return 'Select Message';
	};

	return (
		<Dropdown>
			<DropdownSelectTrigger styles={[s.dropdownTrigger]}>{getTriggerText()}</DropdownSelectTrigger>
			<DropdownContent align='start'>
				{messages.length === 0 ? (
					<DropdownItem onClick={onOpenManageDialog}>Create Custom Message</DropdownItem>
				) : (
					<>
						{messages.map(message => (
							<DropdownItem key={message.id} onClick={() => handleSelectMessage(message)}>
								{message.label}
								{message.id === lastUsedId && ' (Last used)'}
							</DropdownItem>
						))}
						<DropdownSeparator />
						<DropdownItem onClick={onOpenManageDialog}>Manage Messages...</DropdownItem>
					</>
				)}
			</DropdownContent>
		</Dropdown>
	);
};
